import React from 'react';
import { Routes, Route } from 'react-router-dom';

import Layout from './ui/Layout';
import Portal from './pages/Portal';
import Login from './pages/auth/Login';

import AuthGuard from './ui/AuthGuard';

import ManagerList from './pages/manager/ManagerList';
import ManagerCreate from './pages/manager/ManagerCreate';
import ManagerEdit from './pages/manager/ManagerEdit';
import ManagerDetail from './pages/manager/ManagerDetail';
import BoardList from './pages/manager/board/BoardList';
import BoardForm from './pages/manager/board/BoardForm';
import BoardView from './pages/manager/board/BoardView';
import BoardEdit from './pages/manager/board/BoardEdit';
import LeftMenuList from './pages/manager/leftMenu/LeftMenuList';
import PortletList from './pages/manager/portlet/PortletList';
import LogList from './pages/manager/log/LogList';

import UserList from './pages/user/UserList';
import UserCreate from './pages/user/UserCreate';
import UserEdit from './pages/user/UserEdit';
import UserView from './pages/user/UserView';

import DeptList from './pages/dept/DeptList';
import DeptForm from './pages/dept/DeptForm';
import DeptView from './pages/dept/DeptView';
import DeptEdit from './pages/dept/DeptEdit';

import BoardCodeListPage from './pages/code/BoardCodeListPage';
import BoardCodeDetailPage from './pages/code/BoardCodeDetailPage';
import BoardCodeEditPage from './pages/code/BoardCodeEditPage';
import BoardCodeCreatePage from './pages/code/BoardCodeCreatePage';

import AprvFormsList from './pages/aprvForm/AprvFormsList';
import AprvFormsForm from './pages/aprvForm/AprvFormsForm';
import AprvFormsEdit from './pages/aprvForm/AprvFormsEdit';
import AprvFormsView from './pages/aprvForm/AprvFormsView';

import ResourceMng from './pages/resource/ResourceMng';
import RiskCateList from './pages/riskcate/RiskCateList';

import SafetyMaster from './pages/safety/master/SafetyMaster';

document.title = 'TDX 3.0 Manager Admin';
function TdxMain() {

  return (
    <Routes>
      <Route path="/login" element={<Login />} />

      <Route path="/" element={<AuthGuard><Layout><Portal /></Layout></AuthGuard>} />

      <Route path="/manager" element={<AuthGuard><Layout><ManagerList /></Layout></AuthGuard>} />
      <Route path="/manager/create" element={<AuthGuard><Layout><ManagerCreate /></Layout></AuthGuard>} />
      <Route path="/manager/edit/:id" element={<AuthGuard><Layout><ManagerEdit /></Layout></AuthGuard>} />
      <Route path="/manager/left-menu" element={<AuthGuard><Layout><LeftMenuList /></Layout></AuthGuard>} />
      <Route path="/manager/portlet" element={<AuthGuard><Layout><PortletList /></Layout></AuthGuard>} />
      <Route path="/manager/board" element={<AuthGuard><Layout><BoardList /></Layout></AuthGuard>} />
      <Route path="/manager/board/new" element={<AuthGuard><Layout><BoardForm /></Layout></AuthGuard>} />
      <Route path="/manager/board/:id" element={<AuthGuard><Layout><BoardView /></Layout></AuthGuard>} />
      <Route path="/manager/board/:id/edit" element={<AuthGuard><Layout><BoardEdit /></Layout></AuthGuard>} />
      <Route path="/manager/log" element={<AuthGuard><Layout><LogList /></Layout></AuthGuard>} />
      <Route path="/manager/:id" element={<AuthGuard><Layout><ManagerDetail /></Layout></AuthGuard>} />

      <Route path="/users" element={<AuthGuard><Layout><UserList /></Layout></AuthGuard>} />
      <Route path="/users/:id" element={<AuthGuard><Layout><UserView /></Layout></AuthGuard>} />
      <Route path="/users/create" element={<AuthGuard><Layout><UserCreate /></Layout></AuthGuard>} />
      <Route path="/users/edit/:id" element={<AuthGuard><Layout><UserEdit /></Layout></AuthGuard>} />

      <Route path="/dept" element={<AuthGuard><Layout><DeptList /></Layout></AuthGuard>} />
      <Route path="/dept/new" element={<AuthGuard><Layout><DeptForm /></Layout></AuthGuard>} />
      <Route path="/dept/view/:code" element={<AuthGuard><Layout><DeptView /></Layout></AuthGuard>} />
      <Route path="/dept/edit/:code" element={<AuthGuard><Layout><DeptEdit /></Layout></AuthGuard>} />

      <Route path="/board-codes" element={<AuthGuard><Layout><BoardCodeListPage /></Layout></AuthGuard>} />
      <Route path="/board-codes/new" element={<AuthGuard><Layout><BoardCodeCreatePage /></Layout></AuthGuard>} />
      <Route path="/board-codes/:id" element={<AuthGuard><Layout><BoardCodeDetailPage /></Layout></AuthGuard>} />
      <Route path="/board-codes/:id/edit" element={<AuthGuard><Layout><BoardCodeEditPage /></Layout></AuthGuard>} />

      <Route path="/resources" element={<AuthGuard><Layout><ResourceMng /></Layout></AuthGuard>} />

      <Route path="/aprv/forms" element={<AuthGuard><Layout><AprvFormsList /></Layout></AuthGuard>} />
      <Route path="/aprv/forms/new" element={<AuthGuard><Layout><AprvFormsForm /></Layout></AuthGuard>} />
      <Route path="/aprv/forms/:formCode" element={<AuthGuard><Layout><AprvFormsView /></Layout></AuthGuard>} />
      <Route path="/aprv/forms/:formCode/edit" element={<AuthGuard><Layout><AprvFormsEdit /></Layout></AuthGuard>} />

      <Route path="/safety/master" element={<AuthGuard><Layout><SafetyMaster /></Layout></AuthGuard>} />
      <Route path="/safety/master/config" element={<AuthGuard><Layout><SafetyMaster /></Layout></AuthGuard>} />
      <Route path="/safety/master/categories" element={<AuthGuard><Layout><SafetyMaster /></Layout></AuthGuard>} />
      <Route path="/safety/master/processes" element={<AuthGuard><Layout><SafetyMaster /></Layout></AuthGuard>} />

      <Route path="/risk-cate" element={<AuthGuard><Layout><RiskCateList /></Layout></AuthGuard>} />

    </Routes>
  );
}

export default TdxMain;